import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/register/full/page.jsx");
